export function questionFormPopup() {
const checkboxes = document.querySelectorAll('.ginput_container_checkbox .gfield-choice-input');

checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
        if (this.checked) {
            const container = this.closest('.ginput_container_checkbox');
            const containerCheckboxes = container.querySelectorAll('.gfield-choice-input');
            containerCheckboxes.forEach(otherCheckbox => {
                if (otherCheckbox !== this) {
                    otherCheckbox.checked = false;
                }
            });
        }
    });
});

    document.addEventListener("DOMContentLoaded", function() {

    const questionForm = document.querySelector('.question-form');
    const footer = document.querySelector('footer'); 
    const body = document.querySelector('body'); 
    const questionImg = document.querySelector('[data-copy-img]');
    const check = document.querySelector('.gform_button');

    function updateRightDivHeight() {
        const rightDiv = document.querySelector('.right');
        if (!rightDiv) {
            return;
        }
        const rightDivHeight = rightDiv.scrollHeight; 
        rightDiv.style.height = `${rightDivHeight}px`;
    }

    check.addEventListener('click', function() {
        updateRightDivHeight();
    });
    
    if (questionForm && footer) {
        console.log('Question form and footer found. Setting up observer...');
    
        const observer = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && node.classList.contains('gform_confirmation_message--quiz')) {
                        console.log('Quiz confirmation message found. Copying content...');
                        const confirmationContent = node.innerHTML;
                       
                        window.quizResultData = { html: node.innerHTML, text: node.textContent };
                        window.formSubmitted = true;
                       
                        var imgContent = "";
                        if (questionImg && questionImg.innerHTML ) {
                            var imgContent = questionImg.innerHTML;
                        } 

                        console.log(imgContent);

    
                        const confirmationPopup = document.createElement('div');
                        confirmationPopup.classList.add('modal');
                        confirmationPopup.classList.add('confirmation-popup');
                        confirmationPopup.innerHTML =  imgContent + confirmationContent;
    
                        const againButton = node.querySelector('.again'); 
                        if (againButton) {
                            console.log('Button with class "again" found. Adding "again" class to the popup.');
                            confirmationPopup.classList.add('again'); 
                        } else {
                            console.log('No button with class "again" found.');
                            body.classList.add('correct');
                        }
                        footer.parentNode.insertBefore(confirmationPopup, footer);
                        console.log('Confirmation message copied and added above the footer.');
                        body.classList.add('popup-open');
                    }
                });
            });
        });
        const config = { childList: true, subtree: true };
        observer.observe(questionForm, config);
    } else {
        console.error('Question form or footer not found. Observer not set.');
    }
    });
}